<template>
<div class="wrapper">
  <div class="container details">
    <div class="row">
      <div class="col-md-10">
        <h1>Order {{order.id}} {{ customerName }}</h1>
      </div>
      <div class="col-md-2">
        <p class="stateWrapper"><strong>Status: </strong><span :class="order.state">{{ order.state }}</span></p>
        <div v-if="order.data.accepted" class="acceptedWrapper">
          <p><strong>Accepterad av</strong></p>
          <ul>
            <li v-for="(acceptedObject, key) in order.data.accepted" :key="key">
              {{acceptedObject.driverName}}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <TabView>
      <TabPanel header="Information">
        <div class="row">
          <div class="col-md-3" v-for="schemaField in schema.fields" :key="schemaField.id">
            <label>{{ schemaField.label }}</label>
            <p v-if="schemaField.model === 'DeliveryPlace'"> {{ endCustomerName }} </p>
            <p v-if="schemaField.model === 'Quantity'"> {{parseFloat(order.data.Quantity).toFixed(2)}}  </p>
            <p v-else>{{order.data[schemaField.model]}}</p>
          </div>
        </div>
        <div class="row orderDetailsWrapper">
          <div class="col-md-12">
            <form class="formGeneratorWithColumns">
              <vue-form-generator tag="div" :schema="activeSchema" :model="order.data" />
            </form>
          </div>
      </div>
      </TabPanel>
      <TabPanel class="reportedPanel" header="Rapporterat" v-if="order.data.orderRows">
        <h3>Lastbilar</h3>
        <DataTable :value="order.data.trucks" dataKey="id" :expandedRows.sync="expandedRows">
          <Column :expander="true" headerStyle="width: 3em" />
          <Column field="name" header="Namn"></Column>
          <Column field="type" header="Typ"></Column>
          <Column>
          <template #header>
            Total tid
          </template>
            <template #body="slotProps">
             {{getTotalAmount(order.data.orderRows.filter((c) => c.truckId === slotProps.data.id))}}
            </template>
          </Column>
          <template #expansion="slotProps">
              <div class="row">
                <div class="col-md-1"><p><strong>Status</strong></p></div>
                <div class="col-md-1"><p><strong>Starttid</strong></p></div>
                <div class="col-md-1"><p><strong>Sluttid</strong></p></div>
                <div class="col-md-2"><p><strong>Chaufför</strong></p></div>
                <div class="col-md-2"><p><strong>Lastbil</strong></p></div>
                <div class="col-md-2"><p><strong>Artikel</strong></p></div>
                <div class="col-md-3"><p><strong>Totalt</strong></p></div>
              </div>
              <ActivityTable v-for="orderRow in order.data.orderRows.filter((c) => c.truckId === slotProps.data.id)" :activities="orderRow.actions" :orderType="order.type" :orderRow="orderRow" :key="orderRow.id" :customerPlaces="order.data.CustomerPlaces" :showTotal="true" />
              <br/>
              <CreateNewOrderRow :truck="slotProps.data"/>
              <br/>
          </template>
        </DataTable>
        <h3>Artiklar</h3>
         <DataTable :value="articles" dataKey="id">
           <Column field="name" header="Namn"></Column>
           <Column field="type" header="Typ"></Column>
           <Column>
            <template #header>Total tid</template>
            <template #body="slotProps">
              {{getTotalAmount(order.data.orderRows.filter((c) => c.articleId === slotProps.data.articleId))}}
            </template>
           </Column>
        </DataTable>
      </TabPanel>
    </TabView>
  </div>
   <div class="orderButtonsWrapper container">
    <div class="row">
      <div class="col-md-12">
        <SplitButton label="Spara" class="p-button-success" @click="onSave()" :model="saveButtons" icon="pi pi-check"></SplitButton>
        <Button v-if="order.state !== 'makulerad'" label="Kopiera" class="p-button-success" @click="onCopy()" icon="pi pi-file" ></Button>
        <Button v-if="order.state === 'avslutad' && order.state !='fakturaredo'" label="Klar för fakturering" @click="onReadyForInvoice(order)"/>
        <Button v-if="order.state !== 'avslutad'" label="Avsluta" @click="onFinished()"/>
        <Button v-if="order.state!=='makulerad'" label="Makulera" class="p-button-danger" @click="onDelete()"/>
        <!--<Button v-if="order.state !== 'avslutad' && order.state !=='aktiv'" label="Sätt som aktiv" @click="onActivate()"/>-->
        <Button label="Tillbaka" @click="onCancel()"/>
      </div>
    </div>
  </div>
  <Toast position="bottomright" />
</div>
</template>

<script>
import VueFormGenerator from 'vue-form-generator'
import Map from '@/components/Map/Map'
import Toast from 'primevue/toast'
import Dialog from 'primevue/dialog'
import SplitButton from 'primevue/splitbutton'
import Button from 'primevue/button'
import TabView from 'primevue/tabview'
import DataTable from 'primevue/datatable'
import TabPanel from 'primevue/tabpanel'
import Column from 'primevue/column'
import { bus } from '../../main'
import ActivityTable from '@/components/Activities/ActivityTable'
import CreateNewOrderRow from '@/components/Activities/CreateNewOrderRow'
import moment from 'moment'
export default {
  name: 'OrderDetails',
  components: {
    'vue-form-generator': VueFormGenerator.component,
    'Toast': Toast,
    Map,
    Dialog,
    Button,
    ActivityTable,
    TabView,
    DataTable,
    CreateNewOrderRow,
    Column,
    TabPanel,
    SplitButton,
    'moment': moment
  },
  data () {
    return {
      order: {},
      schema: {},
      activeSchema: {},
      customerName: '',
      dataArray: [],
      endCustomerName: '',
      articles: [],
      display: false,
      editMode: false,
      editedActivity: '',
      expandedRows: [],
      opened: [],
      saveButtons: [
        {
          label: 'Skicka till lastbilar',
          icon: 'pi pi-user',
          command: () => {
            this.onReady()
          }
        }
      ]
    }
  },
  watch: {
    '$route' (to, from) {
      this.init()
    }
  },
  created () {
    bus.$on('removedOrderRow', (id) => {
      this.order.data.orderRows = this.order.data.orderRows.filter(function (obj) {
        return obj.id !== id
      })
    })
    bus.$on('addedOrderRow', (orderRow) => {
      this.order.data.orderRows.push(orderRow)
    })
    bus.$on('addedActivity', (obj, id, activity) => {
      let currentOrderRow = this.order.data.orderRows.find(x => x.id === id)
      if (activity.name === 'Sparad' || activity.name === 'Avslutad') {
        currentOrderRow.endTime = activity.startTime
        currentOrderRow.state = 'Avslutad'
      }
      if (activity.name === 'Startad') {
        currentOrderRow.startTime = activity.startTime
      }
      currentOrderRow.actions = obj
    })

    bus.$on('changedActivitiesOrder', (obj, id) => {
      let currentOrderRow = this.order.data.orderRows.find(x => x.id === id)
      currentOrderRow.actions = obj
    })
  },
  async mounted () {
    const data = await this.getOrder()
    this.order = data.order
    this.schema = data.schema
    this.activeInputs()
    this.disabledInputs()
    this.getCustomers()
    this.getTrucks()
    this.getArticles()
    this.getCustomerPlacesByCustomer(this.order.data.kund)
    this.setCustomerPlacesList()
  },
  methods: {
    async init () {
      const data = await this.getOrder()
      this.order = data.order
      this.schema = data.schema
      this.activeInputs()
      this.disabledInputs()
      this.getCustomers()
      this.getTrucks()
      this.getArticles()
      this.getCustomerPlacesByCustomer(this.order.data.kund)
      this.setCustomerPlacesList()
      this.getActiveTruckPosition(this.order.data.trucks)
    },
    async getOrder () {
      let response = await this.$http.get('/api/orders/by-type/hydro/' + this.$route.params.id)
      return response.data
    },
    toggle (id) {
      const index = this.opened.indexOf(id)
      if (index > -1) {
        this.opened.splice(index, 1)
      } else {
        this.opened.push(id)
      }
    },
    addNewRow () {
      this.newOrderRow = {name: '', user: '', startTime: '', endTime: '', amount: '', deliveryPlace: '', comment: '', washPlace: ''}
      this.dialogVisible = true
    },
    setCustomerPlacesList () {
      let that = this
      setTimeout(() => document.querySelector('#kund').addEventListener('change', function () {
        var customerPlacesList = document.querySelector('#leveransstlle')
        var b
        for (b = customerPlacesList.options.length - 1; b >= 0; b--) {
          if (b !== 0) { customerPlacesList.remove(b) }
        }
        that.getCustomerPlacesByCustomer(this.value)
      }), 0)
    },
    getTotalAmount (orderRows) {
      let totalDuration = null
      for (var i = 0; i < orderRows.length; i++) {
        if (orderRows[i].endTime) {
          const pause = orderRows[i].actions.filter(a => a.name === 'Rast').reduce((prev, curr) => {
            return prev.add(moment(curr.endTime).diff(moment(curr.startTime)))
          }, moment.duration(0))
          const work = moment.duration(moment(orderRows[i].endTime).diff(moment(orderRows[i].startTime))).subtract(pause)
          totalDuration += work
        }
      }
      let hours = Math.floor(moment.duration(totalDuration).asHours())
      let mins = Math.floor(moment.duration(totalDuration).asMinutes()) - hours * 60
      if (mins.toString().length < 2) {
        mins = '0' + mins
      }
      return hours + ':' + mins + 'h'
    },
    getActiveTruckPosition (trucks) {
      trucks.forEach((truck) => {
        this.$http
          .get('/api/objectdatasWithGPS/' + truck.id)
          .then(response => {
            let logData = '<div class="logData"><strong>Logg</strong><ul>'
            let truckName = ''
            let driverName = ''
            if (this.order.data.orderRows.length !== 0) {
              let orderRow = this.order.data.orderRows.filter((c) => c.truckId === truck.id)
              if (orderRow !== undefined || orderRow.length > 0) {
                let lastOrderRow = orderRow.slice(-1)[0]
                truckName = lastOrderRow.truckName
                driverName = lastOrderRow.driverName
                for (var c = 0; c < lastOrderRow.actions.length; c++) {
                  var startTime = moment(lastOrderRow.actions[c].startTime).format('MM-DD HH:mm')
                  var endTime = ''
                  if (lastOrderRow.actions[c].endTime) {
                    endTime = '<br/>' + moment(lastOrderRow.actions[c].endTime).format('MM-DD HH:mm')
                  }
                  logData = logData + '<li><span>' + startTime + endTime + '</span><span>' + lastOrderRow.actions[c].name + '</span></li>'
                }
                var activeState = lastOrderRow.actions.slice(-1)[0].name
              }
            }
            if (this.order.data.orderRows.length !== 0) {
              var destination = ''
              if (this.order.data.CustomerPlaces) {
                destination = this.order.data.CustomerPlaces[0].data.name
              }
              logData = logData + '</ul></div>'
              let Data = '<div class="mapInfoWrapper"><strong>' + truckName + '</strong><ul><li><span>Ordernr</span><span>' + this.order.id + '</span></li><li><span>Destination</span><span>' + destination + '</span></li><li><span>Chaufför</span><span>' + driverName + '</span></li></ul>' + logData + '</div>'
              var latestGpsLoc = response.data.GpsPositions.slice(-1)[0]
              let truckObj = { State: activeState, OrderType: this.order.type, Name: truckName, Driver: driverName, Order: this.order, OrderId: this.order.id, Destination: destination, Latitude: latestGpsLoc.lat, Longitude: latestGpsLoc.lon, Title: truckName, Data: Data }
              this.dataArray.push(truckObj)
            }
          })
          .catch(error => console.log(error))
      })
    },
    open () {
      this.display = true
    },
    onChange (event) {
      if (event.target.value) {
        this.activity = event.target.value
        this.display = true
      }
    },
    activeInputs () {
      if (this.schema) {
        this.activeSchema = Object.assign({}, this.schema)
        this.activeSchema.fields = this.activeSchema.fields.filter((c) => c.activeInDetails)
      }
    },
    disabledInputs () {
      this.schema.fields = this.schema.fields.filter((c) => c.activeInDetails === false)
    },
    getCustomers () {
      this.$http
        .get('/api/customers')
        .then(response => {
          var customers = response.data.customers
          var customerSelect = this.activeSchema.fields.find(field => field.model === 'kund')
          for (var i = 0; i < customers.length; i++) {
            customerSelect.values.push({'id': customers[i].id, 'name': customers[i].data.name})
          }
        })
        .catch(error => console.log(error))
    },
    getTrucks () {
      var trucksSelect = this.activeSchema.fields.find(field => field.model === 'trucks')
      this.$http
        .get('/api/objectdatas/objectgroupid/2')
        .then(response => {
          var trucks = response.data
          for (var i = 0; i < trucks.length; i++) {
            if (!trucks[i].data.inActive) {
              trucksSelect.values.push({'id': trucks[i].id, 'name': trucks[i].data.regnbr, 'type': trucks[i].ObjectDescription.name})
            }
          }
        })
        .catch(error => console.log(error))
    },
    getTrailers () {
      var trailersSelect = this.activeSchema.fields.find(field => field.model === 'trailer')
      this.$http
        .get('/api/objectdatas/objectdescriptionid/7')
        .then(response => {
          var trailers = response.data
          for (var i = 0; i < trailers.length; i++) {
            if (!trailers[i].data.inActive) {
              trailersSelect.values.push({'id': trailers[i].id, 'name': trailers[i].data.regnbr})
            }
          }
        })
        .catch(error => console.log(error))
    },
    getArticles () {
      var articlesSelect = this.activeSchema.fields.find(field => field.model === 'articles')
      this.$http
        .get('/api/objectdatas/objectdescriptionid/17')
        .then(response => {
          var articles = response.data
          for (var i = 0; i < articles.length; i++) {
            var ton = ''
            let item = this.order.data.articles.find(x => x.id === articles[i].id)
            if (item) {
              ton = item.ton
            }
            this.articles.push({'id': articles[i].id, 'articleId': articles[i].data.articleId, 'name': articles[i].data.name, 'type': articles[i].data.type, 'ton': ton})
            articlesSelect.values.push({'id': articles[i].id, 'articleId': articles[i].data.articleId, 'name': articles[i].data.name, 'type': articles[i].data.type, 'ton': ton})
          }
        })
        .catch(error => console.log(error))
    },
    getCustomerPlacesByCustomer (customerId) {
      var placesSelect = this.activeSchema.fields.find(field => field.model === 'CustomerPlacesDropDown')
      this.$http
        .get('/api/customersplaces/customer/' + customerId)
        .then(response => {
          var places = response.data.customersplaces.filter(place => place.data.inActive !== true)
          for (var i = 0; i < places.length; i++) {
            placesSelect.values.push({'id': places[i].id, 'name': places[i].data.name + ' ' + places[i].data.city})
          }
        })
        .catch(error => console.log(error))
    },
    getEndCustomer (endCustomerId) {
      this.$http
        .get('/api/customersplaces/endcustomer/' + endCustomerId)
        .then(response => {
          this.endCustomerName = response.data.endcustomer[0].data.slutkundnamn + ' (' + response.data.endcustomer[0].data.slutkundnr + ')'
        })
        .catch(error => console.log(error))
    },
    async onSave () {
      var url = '/api/orders/' + this.order.id
      // Adds customerPlaces to Data
      // const response = await this.$http.get('/api/customersplaces/customer/' + this.order.data.kund)
      const response = await this.$http.get('/api/customersplaces/' + this.order.data.CustomerPlacesDropDown)
      let customerPlacesList = []
      customerPlacesList.push(response.data.customersplace)
      this.order.data.CustomerPlaces = customerPlacesList
      this.$http
        .put(url, {
          order: {
            state: this.order.state = ['aktiv', 'skickad', 'godkänd', 'avslutad'].includes(this.order.state) ? this.order.state : 'uppdaterad',
            data: this._.omit(this.order.data, 'submit')
          }
        })
        .then(response => {
          this.$toast.add({severity: 'success', summary: 'Order sparad', life: 3000})
        })
        .catch(error => console.log(error))
    },
    async onReady () {
      if (this.order.state === 'aktiv') {
        this.order.state = 'aktiv'
      } else {
        this.order.state = 'skickad'
      }
      const response = await this.$http.get('/api/customersplaces/' + this.order.data.CustomerPlacesDropDown)
      let customerPlacesList = []
      customerPlacesList.push(response.data.customersplace)
      this.order.data.CustomerPlaces = customerPlacesList
      var url = '/api/orders/' + this.order.id
      this.$http
        .put(url, {
          order: {
            state: 'skickad',
            data: this._.omit(this.order.data, 'submit'),
            actions: this.activities
          }
        })
        .then(response => {
          this.$toast.add({severity: 'success', summary: 'Sparad och skickad till chaufförer', life: 3000})
        })
        .catch(error => console.log(error))
    },
    onCopy () {
      let message = 'Vill du kopiera ordern?'
      let options = {
        okText: 'Fortsätt',
        cancelText: 'Stäng'
      }
      this.$dialog.confirm(message, options)
        .then(dialog => {
          var copyOrder = Object.assign({}, this.order)
          let data = copyOrder.data
          delete data['orderRows']
          delete data['accepted']
          var url = '/api/orders'
          this.$http
            .post(url, {
              order: {
                type: 'hydro',
                state: 'uppdaterad',
                needsAttention: 0,
                data: this._.omit(data, 'submit')
              }
            })
            .then(response => {
              this.$router.go(-1)
            })
            .catch(error => console.log(error))
        })
        .catch(function () {
          console.log('Clicked on cancel')
        })
    },
    onActivate () {
      var url = '/api/orders/' + this.order.id
      this.$http
        .put(url, {
          order: {
            state: 'aktiv',
            data: this._.omit(this.order.data, 'submit'),
            actions: this.activities
          }
        })
        .then(response => {
          this.order.state = 'aktiv'
          this.$toast.add({severity: 'success', summary: 'Order satt som aktiv', life: 3000})
        })
        .catch(error => console.log(error))
    },
    onDelete () {
      let message = 'Är du säker?'
      let options = {
        okText: 'Fortsätt',
        cancelText: 'Stäng'
      }
      this.$dialog.confirm(message, options)
        .then(dialog => {
          var url = '/api/orders/' + this.order.id
          this.order.state = 'makulerad'
          this.$http
            .put(url, {
              order: {
                id: this.order.id,
                state: 'makulerad',
                data: this._.omit(this.order.data, 'submit')
              }
            })
            .then(response => {
              this.$toast.add({severity: 'success', summary: 'Order makulerad', life: 3000})
            })
            .catch(error => console.log(error))
        })
        .catch(error => console.log(error))
    },
    onCancel () {
      this.$router.go(-1)
    },
    onFinished () {
      let message = 'Vill du avsluta ordern?'
      let options = {
        okText: 'Fortsätt',
        cancelText: 'Stäng'
      }
      this.$dialog.confirm(message, options)
        .then(dialog => {
          this.state = 'avslutad'
          var url = '/api/orders/' + this.order.id
          this.$http
            .put(url, {
              order: {
                state: 'avslutad',
                data: this._.omit(this.order.data, 'submit')
              }
            })
            .then(response => {
              this.$toast.add({severity: 'success', summary: 'Order satt som avslutad', life: 3000})
            })
            .catch(error => console.log(error))
        })
        .catch(function () {
          console.log('Clicked on finish')
        })
    },
    onReadyForInvoice (order) {
      let message = 'Vill du sätta ordern redo för fakturering?'
      let options = {
        okText: 'Fortsätt',
        cancelText: 'Stäng'
      }
      this.$dialog.confirm(message, options)
        .then(dialog => {
          this.state = 'fakturaredo'
          var url = '/api/orders/' + order.id
          this.$http
            .put(url, {
              order: {
                id: order.id,
                state: 'fakturaredo',
                data: this._.omit(order.data, 'submit')
              }
            })
            .then(response => {
              this.$router.go(-1)
            })
            .catch(error => console.log(error))
        })
        .catch(function () {
          console.log('Clicked on cancel')
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Orders/OrderDetails.vue